import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './lib/i18n';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) throw new Error('No #root element found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
